import React from 'react'
import './styles.scss'
interface Props {
  x: [number, number]
  y: number
  val: number
  hideLabel?: boolean
  textAnchor?: 'start' | 'end' | 'middle'
  format?: (a: number) => string
}

export const HorizontalTick = ({
  x,
  y,
  val,
  hideLabel = false,
  textAnchor = 'middle',
  format = m => m.toString()
}: Props) => {
  return (
    <>
      <line x1={x[0]} x2={x[1]} y1={y} y2={y} className='tick' />
      {+val === 0 && (
        <line x1={x[0]} x2={x[1]} y1={y} y2={y} className='tick zero' />
      )}
      {!hideLabel && (
        <>
          {/* <rect
            x={x[0]}
            y={y}
            width={40}
            height={26}
            fill='var(--brand-blue-1)'
            opacity={0.4}
          />{' '} */}
          <text
            x={x[0] + 4}
            y={y + 18}
            className='tick'
            textAnchor={textAnchor}
          >
            {format(val)}
          </text>
        </>
      )}
    </>
  )
}
